import { FC } from 'react';

import { Editor } from 'draft-js';

import * as draftUtils from 'utils/draft';

import { useEditableText } from './functions';
import { IEditableTextProps } from './types';

const EditableText: FC<IEditableTextProps> = ({
  placeholder = 'Please, enter the text...',
  onChange,
  onBlur,
  isReadonly = false,
  autofocus,
  textAlignment = 'left',
  isLineBreak = false,
  stripPastedStyles,
  text = '',
}) => {
  const { editorState, isFocused, handleChange, handleFocus, handleBlur, handleReturn } = useEditableText({
    text,
    onChange,
    onBlur,
    autofocus,
    isLineBreak,
  });

  return (
    <Editor
      placeholder={isFocused ? ' ' : placeholder}
      editorState={editorState}
      onChange={draftUtils.secureOnChange(handleChange)}
      handleReturn={handleReturn}
      onFocus={handleFocus}
      onBlur={handleBlur}
      readOnly={isReadonly}
      textAlignment={textAlignment}
      stripPastedStyles={stripPastedStyles}
    />
  );
};

export default EditableText;
